import React, { memo } from 'react';

const FacebookIcon = (props) => (
    <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.6673 15.4538C26.6673 9.01046 21.444 3.78711 15.0007 3.78711C8.55734 3.78711 3.33398 9.01046 3.33398 15.4538C3.33398 21.8971 8.55734 27.1204 15.0007 27.1204C21.444 27.1204 26.6673 21.8971 26.6673 15.4538ZM16.5169 18.011V27.0225C16.0142 27.0877 15.5079 27.1204 15.001 27.1204C14.2163 27.1204 13.45 27.0424 12.7088 26.8947V18.0115H10.8061V14.8396H12.7088V12.9355C12.7088 10.3478 13.7829 8.80932 16.8352 8.80932H19.3763V11.9815H17.7879C16.5997 11.9815 16.5211 12.4245 16.5211 13.2518L16.5169 14.8393H19.3941L19.0574 18.011H16.5169Z"
            fill="currentColor" />
    </svg>
);

export default memo(FacebookIcon);
